import { buildAnalyticsPath } from "./buildAnalyticsPath";
import type { AnalyticsApiParams } from "./types";

export const events = {
  events_completed: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "events_completed", params),
  total_rsvps: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "total_rsvps", params),
  live_attendance: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "live_attendance", params),
  tickets_sold: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "tickets_sold", params),
  event_revenue: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "event_revenue", params),
  popular_times: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "popular_times", params),
  event_activity: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "event_activity", params),
  popular_events: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "popular_events", params),
  top_attendees: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "top_attendees", params),
  total_rsvps_by_date: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("events", "total_rsvps_by_date", params),
};
